import mail from "../assets/mail-outline.svg"
import "./Contact.css"

export default function Contact(){


    return (
        <div className='contact' data-testid='test-contact'>
            <div className='mail-icon'>
                <img src={mail}></img>
            </div>
            <a href="https://www.zeppelinfloods.com/contact.html" target="_blank">Contact for Purchasing and More Information</a>
        </div>
    )
}